import moment from 'moment';
import { tz } from 'moment-timezone';

export default timezone => ({
  timezone: timezone,
  currentTime: '',
  init() {
    this.updateTime();
    setInterval(() => {
      this.updateTime();
    }, 1000);
  },
  updateTime() {
    this.currentTime = tz(moment(), this.timezone).format('hh:mm:ss a')
  }
})
